module.exports = __webpack_public_path__ + "img/yh_logo.3cefed5b.png";